import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { Location } from 'history';
import { callNativeWeb, footerShowEventWeb } from 'common/appInterface';
import CardApplyStopModal from 'components/CardApplyStopModal';
import { SelectableCard } from 'components/SelectableCard';
import { getVersionUrl } from 'common/cacheOverwrite';

enum CardReceiveMethod {
  NONE = '00',
  IN_PERSON = '01',
  MAILBOX = '02'
}

const CardReceiveMethodSelect = () => {
  const screenId = 'APPL23';

  const location = useLocation() as Location<LocationState>;
  const navigate = useNavigate();

  const { t } = useTranslation();

  const [cardApply] = useState<Partial<CardApplyStep6>>(location.state.apply);
  const [isStop, setStop] = useState(false);
  const [selectedReceiveMethod, setSelectedReceiveMethod] =
    useState<CardReceiveMethod>(CardReceiveMethod.MAILBOX);

  const closeStop = useCallback(() => setStop(false), []);
  const clickNext = useCallback(() => {
    navigate('/apply/step6', {
      state: {
        ...location.state,
        apply: { ...location.state.apply, receiveMethod: selectedReceiveMethod }
      }
    });
  }, [navigate, location.state, selectedReceiveMethod]);

  const callbackBackKeyEvent = useCallback(() => {
    // 수령지변경 처리
    if (cardApply.isChangeDelivery) {
      navigate(-1);
    }
    // 카드발급신청 처리
    else {
      setStop(true);
    }
  }, [navigate, cardApply.isChangeDelivery]);

  useEffect(() => {
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(
      screenId,
      t(screenId + '.title', 'Select Card Receiving Method')
    );
    // 하단바 숨기기
    footerShowEventWeb('N');
    // eslint-disable-next-line
  }, []);

  // 뒤로가기 이벤트 리스너 (backKeyEvent_App (APP > WEB))
  useEffect(() => {
    document.addEventListener('backpress', callbackBackKeyEvent);
    return () =>
      document.removeEventListener('backpress', callbackBackKeyEvent);
  }, [callbackBackKeyEvent, navigate]);

  return (
    <div id="wrap">
      <div id="container">
        <div className={'cardReceiveMethod'}>
          <p className={'title'}>
            {t(screenId + '.explan01', 'How to receive your card?')}
          </p>
          <div className={'content'}>
            <SelectableCard
              title={t(screenId + '.selectTitle01', 'Receive in my mailbox or front door (택배)')}
              description={t(
                screenId + '.selectExplan01',
                'Receive your card without meeting anyone.'
              )}
              selected={selectedReceiveMethod === CardReceiveMethod.MAILBOX}
              showImage
              imageSrc={getVersionUrl(
                '/assets/images/content/img_receive_mailbox.png'
              )}
              onClick={() =>
                setSelectedReceiveMethod(CardReceiveMethod.MAILBOX)
              }
            />
            <SelectableCard
              title={t(screenId + '.selectTitle02', 'Receive in person')}
              description={t(
                screenId + '.selectExplan02',
                'Before delivery, you will receive a call. The card must be received by you in person.'
              )}
              selected={selectedReceiveMethod === CardReceiveMethod.IN_PERSON}
              showImage
              imageSrc={getVersionUrl(
                '/assets/images/content/img_receive_inperson.png'
              )}
              onClick={() =>
                setSelectedReceiveMethod(CardReceiveMethod.IN_PERSON)
              }
            />
          </div>
        </div>
        <div className="btnArea">
          <div className="btnWrapTy01">
            <button
              type="button"
              className="btnPrimaryTy01"
              disabled={CardReceiveMethod.NONE === selectedReceiveMethod}
              onClick={clickNext}>
              <span>{t('COMMON.button.next')}</span>
            </button>
          </div>
        </div>
        <CardApplyStopModal isStop={isStop} closeStop={closeStop} />
      </div>
    </div>
  );
};

export default CardReceiveMethodSelect;
